// @flow

import type {Language, Preferences} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {appActions, appSelectors} from '@/store'

import SlideToggle from '@/controls/slide-toggle'

import './index.css'

type Props = {
  preferences: Preferences,
  savePreferences: (Preferences) => void,
  l: Language,
}

export const RawPreferences = (props: Props) =>
  <div className="auto-monitor-toggle">
    <SlideToggle
      label={props.l('Automatic monitoring')}
      defaultChecked={props.preferences.autoRiskTracker}
      onChange={() =>
        props.savePreferences({
          autoRiskTracker: !props.preferences.autoRiskTracker}
        )
      }
    />
  </div>

const mapStateToProps = (state) => ({
  preferences: state.app.preferences,
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  appActions,
)(RawPreferences)



// WEBPACK FOOTER //
// ./src/views/preferences/index.js